module.exports = __webpack_public_path__ + "img/BY.224a19e6.svg";